module.exports = __webpack_public_path__ + "static/media/about4.c0cae4c5.jpg";